import { loader } from 'graphql.macro'

export default async function disconnectQuickbooks ({ dataLoaders, variables }) {
  const schema = loader('./disconnectQuickbooks.graphql')
  const response = dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      haulerId: variables.haulerId
    }
  })
  return response.disconnectQuickbooks
}
